import { Pipe, PipeTransform } from '@angular/core';

import { Account } from '@libs/src/models/account.model';
import { isTenThousandCoffeesAdmin } from '@main-client/src/app/user/user.helpers';

@Pipe({
  name: 'appIsTenThousandCoffeesAdmin',
  standalone: false,
})
export class IsTenThousandCoffeesAdminPipe implements PipeTransform {
  transform(user: Account): boolean {
    if (!user) {
      return false;
    }
    return isTenThousandCoffeesAdmin(user);
  }
}
